import { render } from "./Terms.vue?vue&type=template&id=7fc39e6c&scoped=true&ts=true"
import script from "./Terms.vue?vue&type=script&lang=ts"
export * from "./Terms.vue?vue&type=script&lang=ts"

import "./Terms.vue?vue&type=style&index=0&id=7fc39e6c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc39e6c"]])

export default __exports__